<template>
  <PermissionForm />
</template>

<script>
import PermissionForm from '@/layouts/components/form/PermissionForm.vue'

export default {
  components: { PermissionForm },
}
</script>
